module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-case-study-2.32071835.webp";